import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function EntertainmentPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-24 bg-gradient-to-br from-red-600 to-orange-500">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-5xl sm:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
              Professional Entertainment Services
            </h1>
            <p className="text-xl text-white/95 max-w-3xl mx-auto">
              Talented performers and entertainers to make your event truly magical and memorable.
            </p>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                  Create Magical Moments
                </h2>
                <p className="text-base text-gray-600 mb-6 leading-relaxed">
                  Our professional entertainers bring joy, laughter, and wonder to events throughout the Lehigh Valley. From birthday parties to corporate events, we have the perfect entertainment to make your celebration unforgettable.
                </p>
                <p className="text-base text-gray-600 mb-8 leading-relaxed">
                  All our performers are experienced professionals who love what they do. They're background-checked, reliable, and dedicated to creating magical memories for guests of all ages.
                </p>
                <Link 
                  to="/contact" 
                  className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
                >
                  Book Entertainment
                </Link>
              </div>
              <div>
                <img 
                  src="https://funaffairs.com/wp-content/uploads/2022/11/balloon-3.png"
                  alt="Entertainment Services"
                  className="w-full rounded-2xl shadow-2xl"
                />
              </div>
            </div>

            <div className="mb-24">
              <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: 'Sora, sans-serif' }}>
                Our Entertainment Options
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-emotion-laugh-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Professional Clowns</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Our world-famous clowns bring laughter and joy with balloon animals, magic tricks, and interactive entertainment.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-magic-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Magicians</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Amazing magic shows that captivate audiences of all ages with illusions, tricks, and interactive performances.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-palette-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Face Painting</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Professional face painters create beautiful designs that kids love. Safe, hypoallergenic paints used.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-user-star-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Character Appearances</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Popular character appearances that bring favorite characters to life at your event.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-balloon-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Balloon Artists</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Skilled balloon artists create amazing balloon sculptures and designs that guests can take home.
                  </p>
                </div>

                <div className="bg-gradient-to-br from-red-50 to-orange-50 p-8 rounded-2xl">
                  <div className="w-14 h-14 flex items-center justify-center bg-red-600 rounded-xl mb-6">
                    <i className="ri-music-fill text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Interactive Shows</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    Engaging interactive shows that get everyone involved in the fun and entertainment.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-12 text-center">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Sora, sans-serif' }}>
                Book Your Entertainment Today
              </h2>
              <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                Contact Fun Affairs to discuss entertainment options for your event in Allentown, Bethlehem, Easton, and the Lehigh Valley.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Link 
                  to="/contact" 
                  className="bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  Get Free Quote
                </Link>
                <a 
                  href="tel:6102532835" 
                  className="bg-gray-900 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-gray-800 transition-colors whitespace-nowrap w-full sm:w-auto"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  (610) 253-2835
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}